import { trace } from 'rytm-helpers';
import { Collapse } from 'bootstrap'

export const initCollapse = () => {
  document.addEventListener("shown.bs.collapse", onCollapseShown);
  document.addEventListener("hiden.bs.collapse", onCollapseHiden);
}

const onCollapseShown = (e) => {
  e.target.parentNode.classList.add("expanded");
  // check URL hash
  const hash = e.target.dataset.id;
  if (hash) {
    // set location hash
    window.location.hash = hash;
  }
}
const onCollapseHiden = (e) => {
  e.target.parentNode.classList.remove("expanded");
}

export const checkCollapse = () => {
  if (window.location.hash) {
    const hash = window.location.hash.replace("#", "");
    const collapseEl = document.documentElement.querySelector('[data-id="' + hash + '"]');
    if (collapseEl) {
      // scroll to element (smooth)
      setTimeout(() => {
        collapseEl.parentNode.scrollIntoView({behavior: "smooth"});
      }, 400)
      // expand collapse
      let bsCollapse = Collapse.getInstance(collapseEl);
      if (bsCollapse === null) {
        bsCollapse = new Collapse(collapseEl, {toggle: false})
      }
      bsCollapse.show();
    }
  }
}